const API_URL = {
  LOGIN: `/v1/admin/login`,
  FORGOT_PASSWORD: `/v1/admin/forgot-password`,
  ME: `/v1/admin/me`,
  LOGOUT: `/v1/admin/logout`,
  CHANGE_PASSWORD: `/v1/admin/change-password`,
  CREATE_PASSWORD: `/v1/admin/create-password`,
  UPDATE_PROFILE: `/v1/admin/update-profile`,
  REFRESH_TOKEN: `/v1/refresh-token`,
  RESET_PASSWORD: (otp: string): string => `/v1/admin/${otp}/reset-password`,
  COMMON: {
    SYNC: `/v1/sync`,
    PRIVILEGES: `/v1/privileges-list`,
    WEBUSERS: `v1/admin/customer/user-list`,
  },
};

export default API_URL;
